import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';

import Dialog from '../../base/ui/components/web/Dialog';
import SignaturePad from "react-signature-canvas";

import { Box } from "@mui/material";
import {openChat, sendSignatureMessage } from "../../chat/actions.web";
import { getParticipantById } from "../../base/participants/functions";

const SignatureDialog = (props) => {
  const signatureRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  const participantObject = getParticipantById(props?.state, props?.participantId)

  const saveSignatureAsBase64 = () => {
    const dataURL = signatureRef.current.toDataURL();
    const base64Signature = dataURL;
  
    const file = dataURLtoFile(dataURL, "signature.png");
  
    const lastModified = file.lastModified;
    const size = file.size;
  
    const signatureData = JSON.stringify({
      oiriginalFile: {
        lastModified: lastModified,
        name: "Signature",
        size: size,
        type: "image/png",
      },
      base64String: base64Signature.toString(),
    });
  
    return signatureData;
  };
  
  function dataURLtoFile(dataURL, filename) {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  

  const handleSubmit = () => {
    dispatch(openChat(participantObject));
    dispatch(sendSignatureMessage(props?.participantId,t('dialog.admitSignatureService')))
    dispatch(sendSignatureMessage(props?.participantId,saveSignatureAsBase64()))

    return true;
  };

  const onClose = () => {
    dispatch(openChat(participantObject));
    dispatch(sendSignatureMessage(props?.participantId,t('dialog.rejectSignatureService')))

    return true;
  };


  return (

    <Dialog
      ok={{ translationKey: "dialog.signature" }}
      onCancel={onClose}
      onSubmit={handleSubmit}
      // titleKey='dialog.signatureTitle'
      titleKey= { t('dialog.signatureTitle', {
        participantName: participantObject.name
    }) }

    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginBottom="15px"
        border="1px solid"
        width="290px"
        margin="0 auto 30px"
      >
        <SignaturePad
          width="100%"
          canvasProps={{
            width: 290,
            border: "3px solid!important",
            height: 400,
          }}
          ref={signatureRef}
          penColor="black"
          backgroundColor="white"
        />
      </Box>
    </Dialog>
  );
};
export function _mapStateToProps(state) {
  return {
      state: state
  };
}
export default translate(connect(_mapStateToProps)(SignatureDialog));